export const ARRAY_LIST_IMAGES_PROPERTY_MOBILI = 'ARRAY_LIST_IMAGES_PROPERTY_MOBILI'
export const ARRAY_LIST_IMAGES360_PROPERTY_MOBILI = 'ARRAY_LIST_IMAGES360_PROPERTY_MOBILI'
export const ARRAY_LIST_VIDEOS_PROPERTY_MOBILI = 'ARRAY_LIST_VIDEOS_PROPERTY_MOBILI'
export const ARRAY_LIST_TOURS_PROPERTY_MOBILI = 'ARRAY_LIST_TOURS_PROPERTY_MOBILI'
export const IS_ACTIVE_BUTTON_PROPERTY_MOBILI = 'IS_ACTIVE_BUTTON_PROPERTY_MOBILI'
export const IS_LOADING_BUTTON_PROPERTY_MOBILI = 'IS_LOADING_BUTTON_PROPERTY_MOBILI'
export const IS_LOADING_FORM_PROPERTY_MOBILI = 'IS_LOADING_FORM_PROPERTY_MOBILI'
export const EVENT_TYPE_PROPERTY_MOBILI = 'EVENT_TYPE_PROPERTY_MOBILI'
export const FORM_DATA_PROPERTY_MOBILI = 'FORM_DATA_PROPERTY_MOBILI'
